import { BLOCK_TIME_EMPTY_VALUE } from '../properties/block-time-record-modal.properties';

/**
 * Formats hours with 2 decimals. An empty or a non-numeric value gives the empty text.
 */
export function formatBlockHours(value: string | number | null | undefined): string {
  const hours = Number(value);

  if (value === null || value === undefined || value === '' || !Number.isFinite(hours)) {
    return BLOCK_TIME_EMPTY_VALUE;
  }

  return hours.toFixed(2);
}
